/**
 * FNV-1a 32-bit hash. Rápido, no criptográfico.
 * Lo usamos para generar claves opacas y checksums de tampering.
 */
export function fnv1a(input: string): number {
  let hash = 0x811c9dc5; // offset basis FNV-1a 32-bit
  for (let i = 0; i < input.length; i++) {
    hash ^= input.charCodeAt(i);
    // multiplicación por el prime FNV usando operaciones de 32 bits
    hash = Math.imul(hash, 0x01000193) >>> 0;
  }
  return hash >>> 0;
}

/**
 * Devuelve el hash FNV-1a como string hex de ancho fijo (8 chars).
 */
export function fnv1aHex(input: string): string {
  return fnv1a(input).toString(16).padStart(8, '0');
}

/**
 * Serialización estable: ordena claves de objetos para que el hash
 * no dependa del orden de inserción.
 */
export function stableStringify(value: unknown): string {
  if (value === null || typeof value !== 'object') {
    return JSON.stringify(value);
  }
  if (Array.isArray(value)) {
    return '[' + value.map(stableStringify).join(',') + ']';
  }
  const obj = value as Record<string, unknown>;
  const keys = Object.keys(obj).sort();
  return (
    '{' +
    keys.map((k) => JSON.stringify(k) + ':' + stableStringify(obj[k])).join(',') +
    '}'
  );
}
